import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'

export default window.customElements.define(
  'hubspot-form',
  class extends CustomElement {
    constructor() {
      super()

      this.onTransitionInStart = this.onTransitionInStart.bind(this)
    }

    connectedCallback() {
      super.connectedCallback()

      Emitter.on('transition-in:start', this.onTransitionInStart)

      this.waitForForm()
    }

    disconnectedCallback() {
      this.waitTimeoutId && clearTimeout(this.waitTimeoutId)
      super.disconnectedCallback()
    }

    waitForForm() {
      if (this.querySelector('.hs-form')) {
        setTimeout(this.onFormReady.bind(this), 100)
      } else {
        this.waitTimeoutId = setTimeout(this.waitForForm.bind(this), 100)
      }
    }

    onFormReady() {
      this.waitTimeoutId && clearTimeout(this.waitTimeoutId)
      this.showRequiredPlaceholders()
    }

    showRequiredPlaceholders() {
      const fields = this.querySelectorAll('.hs-form-field')
      ;[...fields].forEach((field) => {
        const requiredField = field.querySelector('[required][placeholder]')
        const label = field.querySelector('label span:first-child').textContent
        if (requiredField) {
          if (requiredField.placeholder) {
            requiredField.placeholder = `${requiredField.placeholder}*`
          } else {
            requiredField.placeholder = `${label}*`
          }
        } else {
          const input = field.querySelector('[value], textarea')
          input.placeholder = label
        }
      })
    }

    onTransitionInStart() {
      if (!document.body.contains(this)) return
      const scriptEl = Array.from(this.querySelectorAll('script')).find(
        (script) => !script.hasAttribute('src')
      )
      scriptEl && eval(scriptEl.textContent)
    }
  }
)
